import { requestURLs } from "@/Environment";
import { noteSchema } from "@backend/src/schemas/taskSchema";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";
import ApiRequest from "../ApiRequest";
import { TaskNote } from "./useAddTaskNotesMutation";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
type UpdateNoteResponseType = ResponseType<TaskNote>;

function useUpdateNoteMutation(noteId: string) {
  const mutation = useMutation<
    AxiosResponseAndError<UpdateNoteResponseType>["response"],
    AxiosResponseAndError<UpdateNoteResponseType>["error"],
    z.infer<typeof noteSchema>
  >({
    mutationFn: async (data) => {
      return ApiRequest.put<UpdateNoteResponseType>(
        `${requestURLs.taskNote}${noteId}`,
        data
      );
    },
  });

  return mutation;
}

export default useUpdateNoteMutation;